import * as ng from 'angular';
import { ArchiSmallServices } from '../../../services/archismall.service';

class ChangePasswordController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        'ArchiSmallServices',
        '$timeout'
    ];

    private close: any;
    private dismiss: any;

    constructor(
        private $scope: any,
        private $rootScope: any,
        private ArchiSmallServices: ArchiSmallServices,
        private $timeout: ng.ITimeoutService
    ) {

        $scope.tooltips = {
            'password': 'Scegli la tua password, di almeno 8 caratteri alfanumerici, che userai per accedere ad ArchiSMALL. Ti consigliamo di utilizzare lettere maiuscole, minuscole e numeri.',
            'passwordConfirmation': 'Inserisci di nuovo la password. Deve combaciare con la password già inserita.'
        };
        $scope.passwordType = new RegExp('^.{8,}$');

        $scope.changedSuccess = false;
        $scope.updatePassword = () => {
            $scope.updatePasswordObj = {
                'email': $rootScope.user.accountData.email,
                'oldPassword': $scope.oldPassword,
                'newPassword': $scope.newPassword
            };
            ArchiSmallServices.changePassword($scope.updatePasswordObj)
                .then((response: any) => {
                    $scope.changedSuccess = true;
                }, (error) => {
                    if (error.errorCode === $rootScope.ArchiSmallERRORS.INVALID_CURRENT_PASSWORD) {
                        $rootScope.alert('error', 'La password in uso non corrisponde con quella inserita');
                    } else {
                        $rootScope.alert('error', error);
                        $scope.cancel();
                    }
                });
        };
        $scope.validPassword = true;
        $scope.validatePasswords = (password, passwordConfirmation) => {
            if (password === passwordConfirmation) {
                $scope.validPassword = true;
            } else if (password !== undefined && passwordConfirmation !== undefined) {
                $scope.validPassword = false;
            }
        };
        $scope.ok = () => {
            this.close();
        };
        $scope.cancel = () => {
            this.dismiss({ $value: 'cancel' });
        };
    }
}

export const ChangePasswordComponent: ng.IComponentOptions = {
    template: require('./change-password.html'),
    controller: ChangePasswordController,
    bindings: {
        close: '&',
        dismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/change-password/change-password.ts